import {
    getLanguageCookie
} from './language-cookie';
export default class LocalizedStrings {

    constructor(props) {
        this.props = props;
        let language = getLanguageCookie();
        if (!language) {
            language = 'lt';
        }
        this.setLanguage(language);
    }

    setLanguage(language) {

        if (this.props[language]) {
            var localizedStrings = { ...this.props[Object.keys(this.props)[0]],
                ...this.props[language]
            };
            for (var key in localizedStrings) {
                if (localizedStrings.hasOwnProperty(key)) {
                    this[key] = localizedStrings[key];
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/localization/localized-strings.js